import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TYPE_BUTTONS } from '../../../../constans';
import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import H2 from '../../../Basic/WrapsStyle/H/H2';
import Text from '../../../Basic/WrapsStyle/Text';

import UserApi from '../../../../API/user/user-api';
import { addStaff } from '../../../../actions/staff';
import PopUp from '../../../Basic/Blocks/PopUp';
import CheckButton from '../../../Basic/Buttons/Check';
import styles from './styles.module.scss';

export const MAP_ACCESS_SKLADS = {
  msk: 'Москва',
  ekb: 'Екатеринбург',
};
const AccessSkladPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});

  const clickChange = () => {
    console.log(data)
    UserApi.changeUser({ data: { login: user.login, data: { sklads: data } } }).then(() => {
      UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
      close();
    }).catch();
  };

  useEffect(() => {
    setData(user.sklads);
    console.log(user);
  }, [user]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
        <H2 style={{ marginBottom: '10px' }}>Настройка доступов для {user.login}</H2>

        <div className={styles.block}>
          {[...Object.keys(data)]
            .map((key) => {
              return (

                <Row className={styles.block_small} key={key}>
                  <Text fontSize={16} style={{ marginRight: '15px', width: '160px' }}>
                    {MAP_ACCESS_SKLADS[key]}
                  </Text>
                  <CheckButton checked={data[key]} onSelect={() => setData({ ...data, [key]: !data[key] })} />
                </Row>
              );
            })}
        </div>

        <Row style={{ marginTop: '30px' }}>
          <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={clickChange}>
            Сохранить
          </Button>
          <Button type={TYPE_BUTTONS.GREY} onClick={close}>
            Отменить
          </Button>
        </Row>
    </PopUp>
  );
};

export default AccessSkladPopUp;
